import { SbbLoadingIndicatorCircle } from "@sbb-esta/lyne-react/loading-indicator-circle";
import { useQuery } from "@tanstack/react-query";
import { TemplatesTable } from "BoardSettings/TemplatesTable";
import { LyneButton } from "components/Lyne/LyneButton";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { createLogger } from "logging";
import { useApi, useTranslations } from "providers";
import React from "react";

const logger = createLogger("DefaultTemplatesPanel");

interface DefaultTemplatesPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export const DefaultTemplatesPanel: React.FC<DefaultTemplatesPanelProps> = ({ isOpen, onClose }) => {
  const i18n = useTranslations();
  const { templatesApi } = useApi();

  const queryResult = useQuery({
    queryKey: ["default-templates-table"],
    queryFn: async ({ signal }) => {
      const data = await templatesApi.getDefaultTemplatesTable(signal);
      logger.trace("Loaded", data);
      return data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: isOpen,
  });
  const results = queryResult.data;
  const isLoading = queryResult.isFetching;
  const error = queryResult.error;

  return (
    <SlidingPanel
      isOpen={isOpen}
      onCancel={onClose}
      onClose={onClose}
      header={<h1>{i18n.DefaultTemplates_Title}</h1>}
      size={50}
      footer={
        <LyneButton onClick={onClose} kind="ghost">
          {i18n.Actions_Close}
        </LyneButton>
      }
    >
      <div>{i18n.DefaultTemplates_Description}</div>

      {!!error && <div className="alert alert-danger">{String(error)}</div>}

      {isLoading && (
        <div className="py-3 d-flex justify-content-center">
          <SbbLoadingIndicatorCircle />
        </div>
      )}

      {!isLoading && results && <TemplatesTable results={results} />}
    </SlidingPanel>
  );
};
